<div class="top-menu">
  <div><button mat-button>{{ "common.about_us" | translate }}</button></div>
  @if (isUserLoggedIn$ | async) {
    <div><button mat-button>{{ "common.past_donations" | translate }}</button></div>
    @if (isUserLoggedIn$ | async) {
      <div>
        <button [attr.aria-label]="'aria.view_profile' | translate" mat-icon-button [matMenuTriggerFor]="menu">
          <i class="far fa-user-circle btn-header-icon"></i>
        </button>
      </div>
    }
    <mat-menu #menu="matMenu" xPosition="before">
      <div class="flex-row-end">
        <button mat-button class="sm-btn" (click)="logout()">{{ "common.sign_out" | translate }}</button>
      </div>
      <div class="flex-row">
        <div class="circle-container">
          <div class="numberCircle">AA</div>
        </div>
        <div class="profile-descriptions">
          <span> Anis Ali</span>
          <span>anis.ali&#64;protiviti.com</span>
          <button mat-icon-button routerLink="/donar/settings">
            <i class="fas fa-cog"></i>
            {{ "common.settings" | translate }}
          </button>
        </div>
      </div>
    </mat-menu>
  }
  @if (!(isUserLoggedIn$ | async)) {
    <div>
      <button mat-button routerLink="login">{{ "common.log_in" | translate }}</button>
    </div>
  }

</div>
